import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { ClientDetails } from '@core/models/client-details.model';

export interface ClientDetailsState extends EntityState<ClientDetails> {}

export function createInitialState(): ClientDetailsState {
  return null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'clientDetails', resettable: true })
export class ClientDetailsStore extends EntityStore<ClientDetailsState> {
  constructor() {
    super(createInitialState());
  }
}
